'use client'

import { CtaFooter } from '@/modules/academy/components/CtaFooter'

import { GlossaryHeader } from './components/GlossaryHeader'
import { GlossaryTermsList } from './components/GlossaryTermsList'
import { GlossaryTermsNav } from './components/GlossaryTermsNav'
import type { GlossaryTerm } from './glossary.interface'
import { useActiveGlossaryTerm } from './hooks'

import styles from './GlossaryPage.module.scss'

type GlossaryPageProps = {
  terms: GlossaryTerm[]
}

export function GlossaryPage({ terms }: GlossaryPageProps) {
  const { activeTermId, scrollToTerm } = useActiveGlossaryTerm(terms)

  const handleTryGraftcode = () => {
    window.open('https://portal.graftcode.com', '_blank')
  }

  return (
    <div className={styles.page}>
      <div className={styles.body}>
        <div className={styles.mainColumn}>
          <GlossaryHeader />
          <GlossaryTermsList terms={terms} />
        </div>
        <GlossaryTermsNav terms={terms} activeTermId={activeTermId} onTermClick={scrollToTerm} />
      </div>
      <CtaFooter onTryGraftcode={handleTryGraftcode} />
    </div>
  )
}
